import * as React from 'react';
import * as classNames from 'classnames';

import './styles.scss';
import { IFrameAdminMenuItem } from '../../Frames/Admin';
import Overlay from '../Overlay';
import Icon from '../../Components/Icon';

export interface IMenuMobileProps {
    /** Open state */
    isOpen: boolean;
    /** Closing handler */
    doClose: () => void;
    /** List of menu items */
    menuitems: IFrameAdminMenuItem[];
    /** React-router link component to use instead of HTML A tag. If defined href is passed as "to" prop. */
    link?: any;
}

interface IState {
}

/**
 * Renders full menu for mobile
 */
export default class MenuMobile extends React.Component<IMenuMobileProps, IState> {
    static displayName: string = 'MenuMobile';

    render () {
        let Link: any = 'a';
        if (this.props.link) {
            Link = this.props.link;
        }

        return (
            <Overlay
                isOpen={this.props.isOpen}
                doClose={this.props.doClose}
                layout="mainmenu"
                className="menu-mobile"
                customHeader={(
                    <div className="menu-mobile-heading">
                        <button onClick={this.props.doClose}>
                            <Icon kind="close" width={16} height={16}/>
                        </button>
                    </div>
                )}
            >
                <div className="menu-mobile-content">
                    <ul className="menu-mobile-menu">
                        {this.props.menuitems.map((menuitem, index) => {
                            return (
                                <li key={index}>
                                    {menuitem.submenus ? (
                                        <React.Fragment>
                                            {menuitem.href ? (
                                                <Link
                                                    {...(this.props.link ? { to: menuitem.href } : { href: menuitem.href })}
                                                    onClick={menuitem.onClick}
                                                    className={menuitem.active ? 'active' : ''}
                                                >
                                                    <span className="label">{menuitem.name}</span>
                                                </Link>
                                            ) : (
                                                <a
                                                    onClick={menuitem.onClick}
                                                    className={menuitem.active ? 'active' : ''}
                                                >
                                                    <span className="label">{menuitem.name}</span>
                                                </a>
                                            )}
                                            <ul className="menu-mobile-sub">
                                                {menuitem.submenus.map((sub, i) => {
                                                    return (
                                                        <li key={i}>
                                                            {sub.href ? (
                                                                <Link
                                                                    {...(this.props.link ? { to: sub.href } : { href: sub.href })}
                                                                    onClick={sub.onClick}
                                                                    className={classNames({ active: sub.active })}
                                                                >
                                                                    {sub.name}
                                                                </Link>
                                                            ) : (
                                                                <a
                                                                    onClick={sub.onClick}
                                                                    className={classNames({ active: sub.active })}
                                                                >
                                                                    {sub.name}
                                                                </a>
                                                            )}
                                                        </li>
                                                    );
                                                })}
                                            </ul>
                                        </React.Fragment>
                                    ) : (
                                        <Link
                                            {...(this.props.link ? { to: menuitem.href } : { href: menuitem.href })}
                                            onClick={menuitem.onClick}
                                            className={classNames({ active: menuitem.active })}
                                        >
                                            {menuitem.name}
                                        </Link>
                                    )}
                                </li>
                            );
                        })}
                    </ul>
                </div>
            </Overlay>
        );
    }
}
